import React, { useState } from 'react';
import { useSnackbar } from "notistack";
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Button,
	Zoom,
	CircularProgress
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import logo from '../../assets/images/logos/m-clean.png';
import userService from '../../services/userService';
import SuccessAnimationAlert from '../alerts/SuccessAnimationAlert';

const useStyles = makeStyles((theme) => ({
	dialog: {
		maxWidth: '30%'
	},
	label: {
		marginBottom: '5px',
		textAlign: 'left',
		fontSize: '14px',
		color: 'rgba(0, 0, 0, 0.87)'
	}
}));

const ConfirmPostDialog = (props) => {

//	const classes = useStyles();
	const { enqueueSnackbar } = useSnackbar();
	const [loading, setLoading] = useState(false);

	const deleteUserPost = (postId, index) => {
		setLoading(true)
		userService.deletePost(postId)
            .then((res) => {
                setLoading(false)
                if(res.data.success) {
                    props.setConfirmation(true);
					props.setDeletedIndex(index);
                }
            })
            .catch((error) => { 
                setLoading(false)
                if(error) {
                    enqueueSnackbar('Woops! Something went wrong!', {
                        variant: 'error',
                        autoHideDuration: 5000,
                    });
                }
            })
    }

 	return (
 		<>
	    	<Dialog 
	    		open={props.dialogIsOpen} 
	    		onClose={(event, reason) => {
                    if(reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                        props.handleDialogClose(true)
                    }
                }}
	    		aria-labelledby="form-dialog-confirm" 
	    		fullWidth 
			//	classes={{ paperFullWidth: classes.dialog }}
	    		maxWidth="sm"
	    		TransitionComponent={Zoom}
	    	>
				<DialogTitle 
					id="form-dialog-confirm" 
					className="dialog-title"
				>
					<img src={logo} className="mr-1" alt="Mulk.pk" />
					Are you sure you want to delete this post?
				</DialogTitle>
				<DialogContent>
					{props.confirmation && (
						<SuccessAnimationAlert 
							title="Well done!"
							text="Your post has been deleted successfully."
						/>
					)}
					{!props.confirmation && (
						<div className="row pt-1 pb-2 mt-1 mb-2 mx-2">
							<div className="col-md-2 py-2">
								<i className="fas fa-exclamation-triangle fa-4x danger"></i>
							</div>
							<div className="col-md-10 pb-1 text-left">
								<h2 className="my-1">Delete Post</h2>
								<div style={{ fontSize: '14px', lineHeight: '1.5' }}>
									<p className="mb-1">When deleted. It will permanently removed from Mulk.pk webiste and mobile app and you can't restore it.</p>
								</div>
							</div>
						</div>
					)}
				</DialogContent>
		        <DialogActions className="dialog-footer">
		          	<Button 
						onClick={props.handleDialogClose} 
					//	color="primary"
						variant="contained"
						size="small"
					>
		            	Cancel
		          	</Button>
					{!props.confirmation && (
						<Button 
							onClick={() => deleteUserPost(props.postId, props.index)} 
							color="secondary"
							variant="contained"
							size="small"
							disabled={loading}
						>
							{loading && ( 
								<>
									<CircularProgress size={24} />
									<span className="ml-1">Processing...</span>
								</>
							)}
							{!loading && 'Delete'}
						</Button>
					)}
		        </DialogActions>
			</Dialog>
		</>
  	)
}

export default ConfirmPostDialog;